import { ContactDetails } from "../contact/contactDetails";

export default class Facility {
  id: number;
  name: string;
  address: ContactDetails;
  facilityType: string;
}



// WEBPACK FOOTER //
// ./src/models/facilities/facility.ts